"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewEventPage = void 0;
var newEventPage_1 = require("./newEventPage");
exports.NewEventPage = newEventPage_1.default;
